export default function RequireAuth() {
  const ssoURL = process.env.REACT_APP_SSO_LOGIN_URL;
  window.location.href = ssoURL ?? '';
  return null;
}
